import styled, {css} from "styled-components"

interface CardImageWrapperProps {
  image?: string,
  color?: string,
  text?: string,
  isUnavailable?: boolean
}

const getBrandTitleSVG = (text: string) => `
  data:image/svg+xml;utf8,<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 ${text?.length * 10} ${text?.length * 4}">
        <text x="0" y="50%" fill="%23FFF" fill-opacity="55%" font-family="WorkSansBold, sans-serif" font-size="18px">
            ${text}
        </text>
  </svg>`

const repeatedText = css<Pick<CardImageWrapperProps, "text" | "color">>`
  content: "";
  inset: -5vw;
  position: absolute;
  background-size: 16%;
  transform: rotate(-15deg) scale(1.5);
  background-color: ${({color}) => color};
  ${({text}) => text && `background-image: url('${getBrandTitleSVG(text)}');`}
`

export default styled.div<CardImageWrapperProps>`
  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  height: 132px;

  &:before {
    inset: 0;
    content: "";
    position: absolute;

    ${({theme}) => css`
      background-color: ${theme.colors.utility.white};
    `}
    ${({color, image}) => {
    if (!image && color) {
      return repeatedText
    }
    return css`
        background-image: url(${image});
        background-position: center;
        background-size: cover;
      `
  }};
    ${({isUnavailable}) => isUnavailable && "opacity: 60%"}
  }
`
